export default __webpack_public_path__ + "static/orange_arrow-cf668c7513259fac1685ad76cb04cb31.svg";